export const shortenText = (text) => {
    if (text.length < 100) return text;

    return text.split(/(.{100}\S*)\s/s)[1] + " ...";
};